<div class="modal-body">
    <div class="v-center text-center d-flex align-items-center justify-content-center">
        <img
        src="assets/images/virtusa-icons/caution-dark.svg"
        alt="caution"
        width="40px"
        height="40px"
      />
        <span class="core-msg"> {{ data.title || 'Are you sure?' }} </span>
        <span> {{ data.description || "You won't be able to revert this!" }} </span>
    </div>
    
</div>

<div class="d-flex justify-content-center mb-4">
        <button class="btn btn-accello-primary-light mx-2" (click)="this.activeModal.close(true)"> {{ data.confirmText || 'Yes, Delete it' }} </button>
        <button class="btn btn-accello-secondary" (click)="activeModal.dismiss('Cross click')"> {{ data.cancelText || 'Cancel' }} </button>
</div>